export default "__VITE_ASSET__e4e39602__"